import { defineComponent, toRefs } from "vue";
import { store } from "./store/MailAddressChangeStore";
import { Log } from "~/extensions/utils";
import { useLoad } from "../password/composition/Load";
import { useRouter } from "vue-router";
import { commonStore } from "~/store/CommonStore";
import { PageID } from "~/extensions/utils/DefineTypes";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
const log = Log.create("PasswordChangePage");
export default defineComponent({
    name: "MailAddressChangeCompletePage",
    components: {
        BreadcrumbList
    },
    beforeRouteEnter(to, from, next) {
        if (from.name === "mailaddress-check" || !from.name) {
            next();
            return;
        }
        next(false);
    },
    setup() {
        const router = useRouter();
        const hasAddress = history.state.isUpdate;
        // 画面名取得
        const pageName = commonStore.pageName(PageID.mailaddressChangeComplete);
        const onClick = () => {
            if (hasAddress) {
                router.push({ name: "keiyaku" });
            }
            else {
                router.push({ name: "top" });
            }
        };
        return {
            ...toRefs(store),
            ...useLoad(),
            hasAddress,
            onClick,
            pageName,
            PageID
        };
    }
});
